module.exports = __webpack_public_path__ + "img/010.30c33b7b.jpg";